(function ($) {
	"use strict";
	
	/*=============================================
		=    		 Swiper Slider			      =
	=============================================*/
	$('[hp-slider]').each(function () {
		var SwiperCarousel = $(this),
			getDataAttr = function(attr, defaultValue) {
				var value = SwiperCarousel.data(attr);
				return (value !== undefined && value !== null) ? value : defaultValue;
			},
			swiperConfig = {
				slidesPerView: getDataAttr('items', 1),
				loop: getDataAttr('loop', true),
				speed: getDataAttr('speed', 600),
				lazy: getDataAttr('lazy', true),
				spaceBetween: parseInt(getDataAttr('space-between', 20)),
				navigation: {
					nextEl: SwiperCarousel.data('next'),
					prevEl: SwiperCarousel.data('prev'),
				},
				fadeEffect: { crossFade: true },
				autoplay: getDataAttr('autoplay', false),
				breakpoints: {
					480: {
						slidesPerView: getDataAttr('sm-items', 1),
						loop: getDataAttr('sm-loop', true),
						autoplay: getDataAttr('sm-autoplay', false),
						spaceBetween: parseInt(getDataAttr('sm-space-between', 20)),
					},
					750: {
						slidesPerView: getDataAttr('md-items', 1),
						loop: getDataAttr('md-loop', true),
						autoplay: getDataAttr('md-autoplay', false),
						spaceBetween: parseInt(getDataAttr('md-space-between', 20)),
					},
					991: {
						slidesPerView: getDataAttr('lg-items', 1),
						loop: getDataAttr('lg-loop', true),
						autoplay: getDataAttr('lg-autoplay', false),
						spaceBetween: parseInt(getDataAttr('lg-space-between', 20)),
					},
				},
			};
			
		new Swiper(SwiperCarousel[0], swiperConfig);		
	});

      
    // Click event for Tab Heading
    $(".hp-tab-link").click(function(e) {
      e.preventDefault();
      alert(1);
    
      // Reference to the clicked element
      var $this = $(this);
    
      // Remove "active" class from all panels and links within the same tab wrapper
      $this.closest('.tab--wrapper').find('.hp-tab__panel').removeClass("active");
      $this.closest('.tab--wrapper').find('.hp-tab-link').removeClass("active");
    
      // Toggle the "active" class for the clicked tab link
      $this.toggleClass("active");
    
      // Toggle the "active" class for the corresponding tab panel
      var targetPanel = $($this.attr("href"));
      targetPanel.toggleClass("active");
    });

})(jQuery);
